module.exports = __webpack_public_path__ + "img/awards_image_25.5b33fa27.jpg";